import type { ReactNode } from 'react';

/** Device bezel around a screenshot: dark shell, rounded corners, thin inner padding (design: #0b1220, r=40/28). */
export default function PhoneFrame({
  children,
  className = '',
  size = 'lg',
}: {
  children: ReactNode;
  className?: string;
  size?: 'lg' | 'sm';
}) {
  const shell = size === 'lg' ? 'rounded-[32px] p-2 sm:rounded-[40px] sm:p-2.5' : 'rounded-[28px] p-[7px]';
  const screen = size === 'lg' ? 'rounded-[24px] sm:rounded-[30px]' : 'rounded-[21px]';
  return (
    <div className={`bg-[#0b1220] shadow-xl shadow-black/20 ${shell} ${className}`}>
      <div className={`h-full w-full overflow-hidden bg-neutral-200 dark:bg-slate-700 ${screen}`}>{children}</div>
    </div>
  );
}
